<template>
  <section class="event-review-vn" v-show="viewShow">
    <component :is="isPc ? 'pcHeader' : 'h5Header'" select="5" />
    <div v-if="articleHtml" class="article-shell" v-html="articleHtml"></div>
    <div v-else class="article-loading">{{ loadingText }}</div>
  </section>
</template>

<script>
import { mapState } from 'vuex';
import pcHeader from '@/components/header/pc_header';
import h5Header from '@/components/header/h_header';

export default {
  name: 'eventReview2026Vn',
  components: {
    pcHeader,
    h5Header,
  },
  data() {
    return {
      articleHtml: '',
      loadingText: '文章加载中...',
      articlePath: 'eventReview_2026_h5_assets/20260608-01.html',
    };
  },
  computed: {
    ...mapState(['isPc', 'viewShow']),
  },
  mounted() {
    this.loadArticle();
  },
  methods: {
    loadArticle() {
      fetch(this.getArticleUrl())
        .then((response) => {
          if (!response.ok) {
            throw new Error('Article request failed');
          }
          return response.text();
        })
        .then((html) => {
          this.articleHtml = this.normalizeArticleHtml(html);
        })
        .catch(() => {
          this.loadingText = '文章加载失败，请稍后重试';
        });
    },
    getArticleUrl() {
      return `/${this.articlePath}`;
    },
    normalizeArticleHtml(html) {
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      const richMedia = doc.querySelector('.rich_media');

      if (!richMedia) {
        return '';
      }

      const title = doc.querySelector('title');
      if (title && title.textContent) {
        document.title = title.textContent;
      }

      richMedia.querySelectorAll('img').forEach((img) => {
        const src = img.getAttribute('src') || '';
        if (/^file:/i.test(src)) {
          const figure = img.closest('figure');
          if (figure) {
            figure.remove();
          } else {
            img.remove();
          }
          return;
        }
        img.setAttribute('loading', 'lazy');
        img.setAttribute('decoding', 'async');
      });

      richMedia.querySelectorAll('a').forEach((link) => {
        link.setAttribute('target', '_blank');
        link.setAttribute('rel', 'noopener noreferrer');
      });

      const content = richMedia.querySelector('content.article-content');
      if (content) {
        const contentBox = doc.createElement('div');
        contentBox.className = content.className;
        contentBox.innerHTML = content.innerHTML;
        content.parentNode.replaceChild(contentBox, content);
      }

      return richMedia.outerHTML;
    },
  },
};
</script>

<style lang="scss">
.event-review-vn {
  min-height: 100vh;
  background: #f6f7fb;
  color: #2f3640;
  font-family: -apple-system, BlinkMacSystemFont, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "Noto Sans CJK SC", sans-serif;
}

.event-review-vn .article-shell {
  width: 100%;
  padding: 24px 0 42px;
}

.event-review-vn .rich_media {
  width: min(920px, calc(100% - 32px));
  margin: 0 auto;
  padding: 28px 28px 36px;
  background: #fff;
  border: 1px solid #e7eaf0;
  border-radius: 16px;
  box-shadow: 0 10px 30px rgba(19, 35, 78, 0.06);
  line-height: 1.8;
  word-break: break-word;
}

.event-review-vn .rich_media_title {
  margin: 0;
  padding-bottom: 14px;
  border-bottom: 1px solid #e7eaf0;
  color: #1f2a44;
  font-size: 34px;
  font-weight: 700;
  line-height: 1.35;
}

.event-review-vn .rich_media_meta_list {
  display: flex;
  flex-wrap: wrap;
  gap: 10px 16px;
  align-items: center;
  margin: 16px 0 22px;
  color: #8a93a3;
  font-size: 14px;
}

.event-review-vn .rich_media_meta_nickname a {
  color: #5f6b80;
  text-decoration: none;
  pointer-events: none;
  cursor: default;
}

.event-review-vn .article-content {
  color: #333c4d;
  font-size: 20px;
}

.event-review-vn .article-content p,
.event-review-vn .article-content li,
.event-review-vn .article-content blockquote {
  margin: 0 0 16px;
  text-align: justify;
}

.event-review-vn .article-content h2,
.event-review-vn .article-content h3 {
  margin: 28px 0 12px;
  color: #1f2a44;
  line-height: 1.35;
}

.event-review-vn .article-content .article-section-title {
  position: relative;
  margin: 34px 0 18px;
  padding: 12px 16px 12px 20px;
  border-left: 5px solid #d45a22;
  border-radius: 8px;
  background: linear-gradient(90deg, rgba(212, 90, 34, 0.12), rgba(212, 90, 34, 0.03));
  color: #1f2a44;
  font-size: 24px;
  font-weight: 800;
  line-height: 1.45;
}

.event-review-vn .article-content .article-section-title:first-child {
  margin-top: 0;
}

.event-review-vn .article-content a {
  color: #3b5ca8;
  text-decoration: none;
}

.event-review-vn .article-content a:hover {
  text-decoration: underline;
}

.event-review-vn .article-content img {
  display: block;
  width: 100%;
  height: auto;
  border: 1px solid #eef1f7;
  border-radius: 12px;
  background: #fff;
}

.event-review-vn .article-content figure {
  margin: 22px 0;
  text-align: center;
}

.event-review-vn .article-content .award-photo-title {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  margin: 30px 0 14px;
  color: #a34719;
  font-size: 22px;
  font-weight: 800;
  line-height: 1.45;
  text-align: center;
}

.event-review-vn .article-content .award-photo-title::before,
.event-review-vn .article-content .award-photo-title::after {
  content: "";
  flex: 0 1 96px;
  height: 1px;
  background: linear-gradient(90deg, rgba(212, 90, 34, 0), rgba(212, 90, 34, 0.45));
}

.event-review-vn .article-content .award-photo-title::after {
  background: linear-gradient(90deg, rgba(212, 90, 34, 0.45), rgba(212, 90, 34, 0));
}

.event-review-vn .article-content .award-photo-title span {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 36px;
  padding: 4px 18px;
  border: 1px solid rgba(212, 90, 34, 0.22);
  border-radius: 999px;
  background: #fffaf7;
  box-shadow: 0 8px 18px rgba(112, 63, 34, 0.08);
}

.event-review-vn .article-content blockquote {
  padding: 14px 16px;
  border-left: 4px solid #c7d3ea;
  border-radius: 0 12px 12px 0;
  background: #f7f9fc;
}

.event-review-vn .article-content .award-section {
  margin: 24px 0;
}

.event-review-vn .article-content .award-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 16px;
}

.event-review-vn .article-content .award-card {
  padding: 18px 18px 16px;
  border: 1px solid #ead9cf;
  border-radius: 8px;
  background: #fffaf7;
  box-shadow: 0 8px 20px rgba(112, 63, 34, 0.06);
}

.event-review-vn .article-content .award-group-title {
  margin: 0 0 14px;
  padding-bottom: 10px;
  border-bottom: 1px solid rgba(212, 90, 34, 0.18);
  color: #bf4b1d;
  font-size: 20px;
  font-weight: 800;
  line-height: 1.45;
}

.event-review-vn .article-content .award-row {
  margin: 0 0 10px;
  color: #333c4d;
  font-size: 17px;
  line-height: 1.7;
  text-align: left;
}

.event-review-vn .article-content .award-label {
  display: inline-block;
  min-width: 3.4em;
  color: #9b3f18;
  font-weight: 800;
}

.event-review-vn .article-content .award-name-list {
  margin: 0;
  padding-left: 1.2em;
}

.event-review-vn .article-content .award-name-list li {
  margin: 0 0 6px;
  text-align: left;
}

.event-review-vn .article-loading {
  width: min(920px, calc(100% - 32px));
  margin: 24px auto;
  padding: 48px 24px;
  border-radius: 16px;
  background: #fff;
  color: #5f6b80;
  font-size: 16px;
  text-align: center;
}

@media (max-width: 768px) {
  .event-review-vn .article-shell {
    padding: 10px 0 18px;
  }

  .event-review-vn .rich_media {
    width: calc(100% - 20px);
    padding: 16px 14px 24px;
    border-radius: 12px;
  }

  .event-review-vn .rich_media_title {
    padding-bottom: 10px;
    font-size: 24px;
  }

  .event-review-vn .rich_media_meta_list {
    gap: 6px 12px;
    margin: 10px 0 16px;
    font-size: 13px;
  }

  .event-review-vn .article-content {
    font-size: 16px;
  }

  .event-review-vn .article-content .article-section-title {
    margin: 24px 0 14px;
    padding: 10px 12px 10px 14px;
    border-left-width: 4px;
    font-size: 19px;
  }

  .event-review-vn .article-content p,
  .event-review-vn .article-content li,
  .event-review-vn .article-content blockquote {
    margin-bottom: 12px;
  }

  .event-review-vn .article-content figure {
    margin: 14px 0;
  }

  .event-review-vn .article-content .award-photo-title {
    gap: 8px;
    margin: 22px 0 10px;
    font-size: 18px;
  }

  .event-review-vn .article-content .award-photo-title::before,
  .event-review-vn .article-content .award-photo-title::after {
    flex-basis: 42px;
  }

  .event-review-vn .article-content .award-photo-title span {
    min-height: 32px;
    padding: 3px 14px;
  }

  .event-review-vn .article-content .award-grid {
    grid-template-columns: 1fr;
    gap: 12px;
  }

  .event-review-vn .article-content .award-card {
    padding: 14px 14px 12px;
  }

  .event-review-vn .article-content .award-group-title {
    font-size: 17px;
  }

  .event-review-vn .article-content .award-row {
    font-size: 15px;
  }

  .event-review-vn .article-loading {
    width: calc(100% - 20px);
    margin: 10px auto 18px;
    padding: 36px 16px;
    border-radius: 12px;
  }
}
</style>
